<script setup lang="ts">
import portrait360 from '~/assets/images/homepage/cover-portrait-w360.png';
import portrait648 from '~/assets/images/homepage/cover-portrait-w648.png';
import portrait1080 from '~/assets/images/homepage/cover-portrait-w1080.png';
import landscape1000 from '~/assets/images/homepage/cover-landscape-w1000.jpg';
import landscape1500 from '~/assets/images/homepage/cover-landscape-w1500.jpg';
import landscape2000 from '~/assets/images/homepage/cover-landscape-w2000.jpg';
import landscape2500 from '~/assets/images/homepage/cover-landscape-w2500.jpg';
import landscape3000 from '~/assets/images/homepage/cover-landscape-w3000.jpg';
import landscape3500 from '~/assets/images/homepage/cover-landscape-w3500.jpg';
import landscape4000 from '~/assets/images/homepage/cover-landscape-w4000.jpg';

const portraitSrcset = [
  `${portrait360} 360w`,
  `${portrait648} 648w`,
  `${portrait1080} 1080w`,
].join(', ');
const landscapeSrcset = [
  `${landscape1000} 1000w`,
  `${landscape1500} 1500w`,
  `${landscape2000} 2000w`,
  `${landscape2500} 2500w`,
  `${landscape3000} 3000w`,
  `${landscape3500} 3500w`,
  `${landscape4000} 4000w`,
].join(', ');
</script>

<template>
  <div class="h-[70svh] lg:max-h-[670px] relative isolate">
    <h1 class="z-10 text-white text-4xl md:text-6xl font-title font-semibold absolute bottom-[9rem]">
      <span
        class="inline-block bg-secondary-40 px-s lg:px-2xl md:py-m lg:pe-0"
        v-text="$t('homepage.hero.title.1')"
      />
      <br class="lg:hidden">
      <span
        class="inline-block bg-secondary-40 px-s lg:px-2xl md:py-m lg:ps-m"
        v-text="$t('homepage.hero.title.2')"
      />
    </h1>
    <picture class="block object-cover lg:object-top h-full w-full brightness-75 absolute inset-0">
      <source
        :srcset="portraitSrcset"
        media="(orientation: portrait)"
      >
      <source
        :srcset="landscapeSrcset"
        media="(orientation: landscape)"
      >
      <img
        :alt="`${$t('homepage.hero.title.1')} ${$t('homepage.hero.title.2')}`"
        class="block object-cover lg:object-top h-full w-full"
        :src="landscape1500"
      >
    </picture>
  </div>
</template>
